/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Status_LiveInputs */

const bn_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রাফিক লাইভ`)
};

const de_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkehr Live`)
};

const el_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Live`)
};

const en_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Live`)
};

const es_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfico en vivo`)
};

const fr_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafic en direct`)
};

const hi_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैफिक लाइव`)
};

const hu_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Live`)
};

const id_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lalu Lintas Langsung`)
};

const it_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffico in diretta`)
};

const ja_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラフィックライブ`)
};

const ko_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교통 라이브`)
};

const nl_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkeerslive`)
};

const pl_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruch na żywo`)
};

const pt_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfego ao vivo`)
};

const ru_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трафик в прямом эфире`)
};

const sv_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik Live`)
};

const tr_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik Canlı`)
};

const uk_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трафік в прямому ефірі`)
};

const vi_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thông trực tiếp`)
};

const zh_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时路况`)
};

const zh_hant_cipher_status_live = /** @type {(inputs: Cipher_Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即時路況`)
};

/**
* | output |
* | --- |
* | "Traffic Live" |
*
* @param {Cipher_Status_LiveInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_status_live = /** @type {((inputs?: Cipher_Status_LiveInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Status_LiveInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_status_live(inputs)
	if (locale === "de") return de_cipher_status_live(inputs)
	if (locale === "el") return el_cipher_status_live(inputs)
	if (locale === "en") return en_cipher_status_live(inputs)
	if (locale === "es") return es_cipher_status_live(inputs)
	if (locale === "fr") return fr_cipher_status_live(inputs)
	if (locale === "hi") return hi_cipher_status_live(inputs)
	if (locale === "hu") return hu_cipher_status_live(inputs)
	if (locale === "id") return id_cipher_status_live(inputs)
	if (locale === "it") return it_cipher_status_live(inputs)
	if (locale === "ja") return ja_cipher_status_live(inputs)
	if (locale === "ko") return ko_cipher_status_live(inputs)
	if (locale === "nl") return nl_cipher_status_live(inputs)
	if (locale === "pl") return pl_cipher_status_live(inputs)
	if (locale === "pt") return pt_cipher_status_live(inputs)
	if (locale === "ru") return ru_cipher_status_live(inputs)
	if (locale === "sv") return sv_cipher_status_live(inputs)
	if (locale === "tr") return tr_cipher_status_live(inputs)
	if (locale === "uk") return uk_cipher_status_live(inputs)
	if (locale === "vi") return vi_cipher_status_live(inputs)
	if (locale === "zh") return zh_cipher_status_live(inputs)
	return zh_hant_cipher_status_live(inputs)
});